import React, { PureComponent } from 'react';

class Dropdown extends PureComponent {
    state = {
        open: false
    }

    render() {
        const { open } = this.state;
        const { compareToIndustry, setCompareToIndustry } = this.props;
        return (
            <div className={open ? 'dropdown __open' : 'dropdown'}>
                <div className="row align-items-center">
                    <div className="col-auto d-none d-sm-block">
                        <div className="dropdown-you">YOU</div>
                    </div>
                    <div className="col-auto d-none d-sm-block">
                        <div className="dropdown-vs">vs</div>
                    </div>
                    <div className="col-auto">
                        <div className={compareToIndustry == null ? "dropdown-trigger" : compareToIndustry ? "dropdown-trigger __similar" : "dropdown-trigger __british"} onClick={() => this.setState({ open: !open })}>

                            {compareToIndustry == null ? 'Make a selection' : compareToIndustry ? 'SIMILAR JOBS TO YOURS' : 'UK AVERAGE'}
                            
                            {open && (
                                <div className="dropdown-options">
                                    {(compareToIndustry == null || compareToIndustry == false) && (
                                        <div onClick={() => setCompareToIndustry(true)} className="dropdown-option __similar">
                                            SIMILAR JOBS TO YOURS
                                        </div>
                                    )}
                                    {(compareToIndustry == null || compareToIndustry == true) && (
                                        <div onClick={() => setCompareToIndustry(false)} className="dropdown-option __british">
                                            UK AVERAGE
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                        
                    </div>
                </div>
                
            </div>
        );
    }
}

export default Dropdown;


// WEBPACK FOOTER //
// ./src/Results/Dropdown.js